import React from 'react';
import PropTypes from 'prop-types';
import './LightboxContainerDesktop.css';

class LightboxContainerDesktop extends React.Component {
	constructor(props) {
    super(props);
  }

  closeIcon = () => {
    const { lang, closeLightBox } = this.props;

    return (
      <i
        className="fa fa-times close"
        onClick={e => closeLightBox(e)}
        onKeyDown={() => {}}
        role="presentation"
      >
        <span>{lang.close}</span>
      </i>
    );
  }

	render() {
    const {
      showImage,
      activeImage,
      galleryImages,
      setImage
    } = this.props;

    const isLastImage = galleryImages.length === (activeImage + 1);
    const isFirstImage = activeImage === 0;

    return (
      <div className="lightboxContainerDesktop" >
        { this.closeIcon() }
        { !isLastImage && <i className="fa fa-angle-right pager" aria-hidden="true" onClick={() => setImage()} /> }
        { <img src={showImage} alt="" />}
        { !isFirstImage && <i className="fa fa-angle-left pager" aria-hidden="true" onClick={() => setImage(false)} /> }
      </div>
    );
  }
}

LightboxContainerDesktop.defaultProps = {
  lang: {},
  closeLightBox: () => {},
  showImage: '',
  activeImage: 0,
	galleryImages: [],
  setImage: () => {},
};
  
LightboxContainerDesktop.propTypes = {
  lang: PropTypes.object,
  closeLightBox: PropTypes.func,
  showImage: PropTypes.string,
  activeImage: PropTypes.number,
	galleryImages: PropTypes.array,
  setImage: PropTypes.func,
};

export default (LightboxContainerDesktop);



// WEBPACK FOOTER //
// ./src/components/lightbox/lightbox-container-desktop/LightboxContainerDesktop.jsx